import request from '@/service/request'

export function addOne(data, uuid = '') {
    return request({
        url: '/szpu/pm_add',
        method: 'post',
        data,
        headers: {
            uuid: uuid
        }
    })
}

export function edit(data, uuid = '') {
    return request({
        url: '/szpu/pm_edit',
        method: 'post',
        data,
        headers: {
            uuid: uuid
        }
    })
}

export function delOne(data, uuid = '') {
    return request({
        url: '/szpu/pm_delete',
        method: 'post',
        data,
        headers: {
            uuid: uuid
        }
    })
}

export function delAll(data, uuid = '') {
    return request({
        url: '/szpu/pm_delete_all',
        method: 'post',
        data,
        headers: {
            uuid: uuid
        }
    })
}

export function getList(data, uuid = '') {
    return request({
        url: '/szpu/pm_list',
        method: 'get',
        data,
        headers: {
            uuid: uuid
        }
    })
}

export function upLevel(data, uuid = '') {
    return request({
        url: '/szpu/pm_up_level',
        method: 'post',
        data,
        headers: {
            uuid: uuid
        }
    })
}

export function downLevel(data, uuid = '') {
    return request({
        url: '/szpu/pm_down_level',
        method: 'post',
        data,
        headers: {
            uuid: uuid
        }
    })
}

export function complete(data, uuid = '') {
    return request({
        url: '/szpu/pm_complete',
        method: 'post',
        data,
        headers: {
            uuid: uuid
        }
    })
}

export function taskDrag(data, uuid = '') {
    return request({
        url: '/szpu/pm_drag',
        method: 'post',
        data,
        headers: {
            uuid: uuid
        }
    })
}

export function aiGen(data, uuid = '') {
    return request({
        url: '/szpu/pm_ai_gen',
        method: 'post',
        data,
        headers: {
            uuid: uuid
        }
    })
}

export function importTask(data, uuid = '') {
    return request({
        url: '/szpu/pm_add_tasks',
        method: 'post',
        data,
        headers: {
            uuid: uuid
        }
    })
}







